import { ICategory } from 'src/models';

// 카테고리리스트에서 drag한 카테고리 찾기
const findCategoryInTree = (categories: ICategory[], targetSid: number): ICategory | undefined => {
  for (const category of categories) {
    if (category.categorySid === targetSid) return category;
    if (category.children) {
      const found = findCategoryInTree(category.children, targetSid);
      if (found) return found;
    }
  }
  return undefined;
};

export default findCategoryInTree;
